import greenoAdvice from "../../../../assets/greeno-hint.gif";

const GreenoMessage = ({ currentStep }) => {
  const isLoading = !currentStep;

  return (
    <div className="absolute inset-0 left-0 z-10 rounded pr-6">
      <div className="flex h-full flex-col items-end gap-6 md:flex-row">
        <img src={greenoAdvice} alt="Greeno Hint" className="h-auto w-24" />
        <div className="relative">
          <div className="custom-scrollbar mb-20 flex max-h-80 min-h-20 max-w-128 items-center justify-center overflow-auto whitespace-pre-wrap rounded bg-[#F0E29A] p-4 px-6 text-gray-700">
            {isLoading ? (
              <div className="flex h-full w-32 items-center justify-center">
                <div className="h-6 w-6 animate-spin rounded-full border-4 border-gray-500 border-t-transparent" />
              </div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: currentStep }} />
            )}
          </div>
          <div className="clip-triangle absolute bottom-24 left-[-25px] h-10 w-10 bg-[#F0E29A]" />
        </div>
      </div>
    </div>
  );
};

export default GreenoMessage;
